import React from "react";
import ApproveButton from "@components/FlowActionButtons/ApproveButton";
import { canUserApprove } from "@features/vessel-call/vessel-call-status/ShippingAgencyTransfer/flow/utils";
import type { ShippingAgencyTransfer } from "@services/shipping-agency-transfer/types";

interface ApproveShippingAgencyTransferProps {
  transferDetails: ShippingAgencyTransfer | null;
  onApprove: () => void;
}

const LANG_BASE = "vessel-call.shipping-agency-transfer";

const ApproveShippingAgencyTransfer: React.FC<ApproveShippingAgencyTransferProps> = ({
  transferDetails,
  onApprove,
}) => {
  if (!transferDetails?.task) {
    return null;
  }

  const isActionAvailable = canUserApprove(
    transferDetails.task.status,
    transferDetails.task.claimOwnerName,
    transferDetails.status,
  );

  return (
    <ApproveButton
      langBase={`${LANG_BASE}.flow-buttons`}
      permission="canApproveShippingAgencyTransfer"
      isActionAvailable={isActionAvailable}
      onApprove={onApprove}
    />
  );
};

export default ApproveShippingAgencyTransfer;
